// Avatar initials for a user/display name — always 2 characters where possible.
// Multi-word names use the first letter of the first two words ("John Doe" → "JD");
// single-word names use the first two letters ("Admin1" → "AD", "JC_TL" → "JC").
// Only whitespace separates words, so "JC_TL" stays one token and keeps "JC".
export const getInitials = (name = '') => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
};

export default getInitials;
